import Swiper from "swiper";
import { Navigation } from "swiper/modules";

new Swiper(".cases__slider", {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".cases__next",
        prevEl: ".cases__prev",
    },
});
